export const CREATE_INSTRUCTION_CANCEL_CONFIRMATION_TITLE =
  "Oh no! You are so close to creating a new instruction, are you sure you want to cancel?"
export const CREATE_INSTRUCTION_CANCEL_CONFIRMATION_TEXT =
  "By cancelling now your new instruction information will not be saved.\n" +
  "Click on “Go Back” if this action was a mistake."

export const EDIT_INSTRUCTION_CANCEL_CONFIRMATION_TITLE = "Are you sure you want to cancel?"
export const EDIT_INSTRUCTION_CANCEL_CONFIRMATION_TEXT =
  "By cancelling now any change you have done will not be stored and you will return the instructions list view.\n" +
  "Click on “Go Back” if this action was a mistake."

export const CREATE_INSTRUCTION_TOAST_MESSAGE = "Instruction successfully created."
export const UPDATE_INSTRUCTION_TOAST_MESSAGE = "Instruction successfully updated."

export const CREATE_INSTRUCTION_DIALOG_TITLE = "Create New Instruction"
export const EDIT_INSTRUCTION_DIALOG_TITLE = "Edit Instruction"
